import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "transportation-container row row-cols-2 row-cols-1 m-0 mb-3" }
const _hoisted_2 = { class: "transportation-container__item-1 p-0 d-flex flex-row justify-content-between col-sm-12 col-lg-6 col-xxl-2" }
const _hoisted_3 = { class: "w-100 d-flex flex-column align-items-center justify-content-center" }
const _hoisted_4 = { class: "transportation-container__item-1__time" }
const _hoisted_5 = {
  key: 0,
  class: "transportation-container__item-1__travel-time"
}
const _hoisted_6 = { class: "transportation-container__item-2 p-0 d-flex flex-row justify-content-between col-sm-12 col-lg-6 col-xxl-3" }
const _hoisted_7 = { class: "w-100 d-flex flex-column justify-content-center align-items-xxs-center align-items-sm-center align-items-xxl-start p-4" }
const _hoisted_8 = { class: "transportation-container__item-2__route" }
const _hoisted_9 = ["data-bs-target"]
const _hoisted_10 = { class: "ms-2" }
const _hoisted_11 = { class: "transportation-container__item-3 p-0 d-flex flex-row justify-content-between align-items-center col-sm-12 col-lg-6 col-xxl-4" }
const _hoisted_12 = { class: "transportation-container__item-4 p-0 d-flex align-items-center justify-content-center col-sm-12 col-lg-6 col-xxl-3" }
const _hoisted_13 = { class: "transportation-container__item-4__inner d-flex flex-column justify-content-center align-items-xxs-center h-100 align-items-end" }
const _hoisted_14 = { class: "transportation-container__item-4__inner__cost" }
const _hoisted_15 = { class: "transportation-container__item-4__inner__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VehicleCardFreeItemWrapperComponent = _resolveComponent("VehicleCardFreeItemWrapperComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_TransportationStopsModalContentComponent = _resolveComponent("TransportationStopsModalContentComponent")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.transportation.pickup_time) + " - " + _toDisplayString(_ctx.transportation.drop_off_time), 1),
        (_ctx.transportation?.travel_time)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('duration')) + " " + _toDisplayString(_ctx.transportation.travel_time.split(':')[0]) + _toDisplayString(_ctx.$t('shortened_hours')) + " " + _toDisplayString(_ctx.transportation.travel_time.split(':')[1]) + _toDisplayString(_ctx.$t('shortened_minutes')), 1))
          : _createCommentVNode("", true)
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "transportation-container__line" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.transportation.title), 1),
        _createElementVNode("div", {
          class: "transportation-container__item-2__map d-flex flex-row",
          "data-bs-toggle": "modal",
          "data-bs-target": `#transportation-route-map-${_ctx.transportation.id}`
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("img", {
            src: "/assets/images/map-icon.svg",
            alt: ""
          }, null, -1)),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('journey_map')), 1)
        ], 8, _hoisted_9)
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "transportation-container__line" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_VehicleCardFreeItemWrapperComponent, { class: "column-gap p-4 justify-content-center w-100" }),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "transportation-container__line" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, _toDisplayString(parseFloat((_ctx.transportation.totals.tax_total).toFixed(2))) + " " + _toDisplayString(_ctx.$t('symbol_eur')), 1),
        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('price_per_person')), 1)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_ButtonComponent, {
          class: "transportation-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('select-transportation', {transportationId: _ctx.transportation.id})))
        }, {
          btnContent: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(_ctx.placeholder)), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_ModalComponent, {
      "show-title": false,
      "id-data": `transportation-route-map-${_ctx.transportation.id}`
    }, {
      "body-content": _withCtx(() => [
        _createVNode(_component_TransportationStopsModalContentComponent, { data: _ctx.transportation }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["id-data"])
  ]))
}